import { Button, ButtonGroup, Divider } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import ContentConstants from '../../contentConstants';
import {
	IClientParticipantActionCreators,
	IQuestionModalActionCreators,
	ISurveyActionCreators,
	ISurveyBuilderActionCreators,
	UserType,
} from '../../models';
import { ISurveyBuilderState } from '../../store/SurveyBuilderStore';
import { ISurveyState } from '../../store/SurveyStore';
import { CardLayout, SaveButtonsContainer } from '../common';
import { SurveyNoteHeaderContainer } from '../notes/SurveyNoteHeaderContainer';
import { SurveyTitleIntroSection, TextToSpeechInstructionsSection } from './define-survey-content';

export type IDefineSurveyContentProps = {
	match: { params: { surveyId?: string } };
	isQuestionChangesLoading: boolean;
} & ISurveyBuilderState &
	ISurveyState &
	ISurveyBuilderActionCreators &
	ISurveyActionCreators &
	IQuestionModalActionCreators &
	IClientParticipantActionCreators & {
		// TODO: This is also on SurveyBasics. Should this be moved to SurveyBuilderState?
		userType: UserType;
	};

export class DefineSurveyContent extends React.PureComponent<IDefineSurveyContentProps> {
	public componentDidMount() {
		const paramsSurveyId = parseInt(this.props.match.params.surveyId!, 10);
		this.props.GetConfiguredParticipantAttributes(paramsSurveyId);
	}

	public render() {
		const {
			surveyEditModel,
			validationResults,
			isValid,
			userType,
			HandleTextToSpeechInstructionsUpdate,
			HandleTextToSpeechInstructionsChange,
		} = this.props;

		return (
			<CardLayout
				loading={this.props.isLoading}
				title={ContentConstants.TITLE_DEFINE_SURVEY_CONTENT}
				header={<SurveyNoteHeaderContainer />}
			>
				<SurveyTitleIntroSection
					{...this.props}
					surveyEditModel={surveyEditModel}
					isValid={isValid}
					validationResults={validationResults}
				/>
				{userType === UserType.Internal && surveyEditModel.survey.isTextToSpeechEnabled && (
					<TextToSpeechInstructionsSection
						surveyEditModel={surveyEditModel}
						HandleInstructionsUpdate={HandleTextToSpeechInstructionsUpdate}
						HandleInstructionsChange={HandleTextToSpeechInstructionsChange}
					/>
				)}
				<Divider type='dashed' />
				<SaveButtonsContainer>
					<ButtonGroup type='column'>
						<Button id='PreviousStepButton' color='secondary' onClick={() => this.props.PreviousStep()} size='lg'>
							{ContentConstants.BUTTONS_PREVIOUS_STEP}
						</Button>
						<Button id='SaveButton' color='secondary' onClick={() => this.props.Save(false)} size='lg' disabled={this.props.saving}>
							{ContentConstants.BUTTONS_SAVE}
						</Button>
						<Button id='SaveAndNextStepButton' color='primary' onClick={() => this.props.Save(true)} size='lg' disabled={this.props.saving}>
							{ContentConstants.BUTTONS_SAVE_AND_NEXT}
						</Button>
					</ButtonGroup>
				</SaveButtonsContainer>
			</CardLayout>
		);
	}
}
